import MigrationSignupSection from "../Components/MigrationSignupSection";
import Title from "../Common/Title";
import {Typography} from "@sgi/gravity/Typography";
import {Flex} from "@chakra-ui/react";
import {ReactNode, useState} from "react";
import ButtonLink from "../Components/ButtonLink";
import {useRedirectToMySGI} from "../Custom Hooks/useRedirectToMySGI";

export enum MigrationAction {
  None,
  SendCode,
  PromptChangeEmail,
  ChangeEmail
}

interface MigrationProps {
  defaultMigrationAction: MigrationAction;
}

export default function Migration(props: MigrationProps) {
  const [migrationAction, setMigrationAction] = useState<MigrationAction>(props.defaultMigrationAction);
  const handleClick = useRedirectToMySGI();

  let titleText: string;
  let description: ReactNode;
  switch (migrationAction) {
    case MigrationAction.SendCode: {
      titleText = "Confirm your details";
      description = (
        <Typography variant="body" mb={8}>Use the verification code we sent you to confirm your account.</Typography>
      );
      break;
    }
    case MigrationAction.ChangeEmail: {
      titleText = "Change email address";
      description = (
        <Typography variant="body" mb={8}>Enter your new email address for your MySGI account.</Typography>
      );
      break;
    }
    default: {
      titleText = "Hi,";
      const customerFirstName = (document.getElementById("customerFirstName")?.innerHTML ?? "").trim();
      if (customerFirstName) titleText += ` ${customerFirstName}!`;
      description = (
        <>
          <Typography variant="bodyBold" mb={customerFirstName ? undefined : 8}>
            It's time to update your account.
          </Typography>
          {customerFirstName && (
            <Typography variant="body" mb={8} data-testid="not-you-test">
              Not you? <ButtonLink handleClick={handleClick} linkCaption="Click here" /> to
              sign in to your own MySGI account.
            </Typography>
          )}
          <Typography variant="body" mb={8}>
            To start, enter and verify your own email address.
            You'll use this to sign in to MySGI.
            It can't be used by another MySGI account.
          </Typography>
        </>
      );
      break;
    }
  }

  return (
    <Flex direction="column" maxW={544} padding={38} mx="auto">
      <Title text={titleText} data-testid="title-test"/>
      {description}
      <MigrationSignupSection migrationAction={migrationAction} setMigrationAction={setMigrationAction}/>
    </Flex>
  );
}
